import {
  Box,
  Button,
  FormControl,
  FormGroup,
  Input,
  InputLabel,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { sagaActions } from "../../redux/sagas/sagaActions";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATH } from "../../helper/Constants";
import { getSessionStorage } from "../../helper/Storage";

const Login = () => {
  const user = useSelector((state) => state.user);

  const [t] = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = () => {
    dispatch({
      type: sagaActions.USER_LOGIN_REQUEST,
      data: {
        username: username,
        password: password,
      },
    });
  };

  useEffect(() => {
    const accessToken = getSessionStorage("token");
    if (!user?.error && accessToken) {
      navigate("/" + ROUTE_PATH.HOME);
    }
  }, [user, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "70vh",
      }}
    >
      <Box
        sx={{
          maxWidth: "300px",
          border: "1px solid #e2e2e2",
          padding: "15px",
          borderRadius: "5px",
        }}
      >
        <Typography variant="h4">{t("login.head")}</Typography>
        <FormGroup>
          <FormControl sx={{ display: "block", paddingBottom: "15px" }}>
            <InputLabel htmlFor="username">{t("login.username")} *</InputLabel>
            <Input
              required
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </FormControl>
          <FormControl sx={{ display: "block", paddingBottom: "15px" }}>
            <InputLabel htmlFor="password">{t("login.password")} *</InputLabel>
            <Input
              required
              id="password"
              value={password}
              type="password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </FormControl>
          <Button
            disabled={!username || !password}
            variant="contained"
            onClick={handleSubmit}
          >
            {t("submit")}
          </Button>
        </FormGroup>
        {user?.error && (
          <Typography sx={{ color: "#ff0000", padding: "5px 0" }}>
            {t("login." + user?.error?.toLowerCase())}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default Login;
